// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1DXrH","requiredAsterisk":"Info_requiredAsterisk__Uu9sv"};